import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const CLASSESJUDICIAIS_URL = BASE_URL + "pje/seam/resource/rest/pje-legacy/ApoioIRDR/classejudicial"
export const useClasseJudicialStore = defineStore('classejudicial', {
  state: () => ({ classes: [], filtered: [] }),
  getters: {
    get: state => state.classes,
    all: state => state.classes
  },
  actions: {
    async fetch() {
      const { data } = await Axios.get(CLASSESJUDICIAIS_URL + "?codigo=&descricao=")
      const listaDeClasses = data
      this.classes = Object.entries(listaDeClasses).map(e => ({ id: e[0], descricao: e[1] }))
      return this.classes
    },
  },
})
